<template>
  <v-container class="estrutura-organizacional">
    <v-card
      class="py-4 px-2"
      tile
    >
      <v-form>
        <PageTitle
          main="Gestão da Câmara"
          icon="mdi-pencil-box-outline"
          sub="Estrutura organizacional"
          home="/gestao-da-camara"
        />
        <input
          id="user-id"
          type="hidden"
          v-model="estrutura.usuario"
        />
        <input
          id="estrutura-id"
          type="hidden"
          v-model="estrutura.id"
        />
        <input
          id="estrutura-uuid"
          type="hidden"
          v-model="estrutura.uuid"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
            >
              <v-btn
                class="btn-outer-right pa-0"
                slot="append"
                color="success"
                tile
                @click.prevent="loadDialog"
              >
                <v-icon
                  class="mx-0"
                  color="white"
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="codigo"
          >
            <v-checkbox
              v-model="estrutura.inativar"
              label="Inativar estrutura?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="estrutura.nome"
              label="Título da estrutura"
              required
              dense
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
            lg="3"
            class="mr-0 pr-0"
          >
            <v-text-field
              class="codigo mr-0"
              v-model="estrutura.uid_agente"
              label="Código..."
              dense
              outlined
              flat
              @change="loadPessoaId()"
            >
              <v-btn
                class="btn-outer pa-0"
                slot="append"
                color="success"
                tile
                @click="loadFtPessoa"
              >
                <v-icon
                  class="mx-0"
                  color="white"
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
              <v-btn
                class="btn-outer-right pa-0"
                slot="append"
                color="light"
                tile
                @click="loadAddPessoa"
              >
                <v-icon
                  class="mx-0"
                  color="black"
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="7"
            lg="5"
            class="mx-0 px-0"
          >
            <input
              type="hidden"
              id="agente-estrutura"
              v-model="estrutura.agente"
            />
            <v-text-field
              class="v-busca-nome ml-0"
              v-model="pessoaSearchEst"
              :loading="loading"
              aria-autocomplete="none"
              :search-input.sync="search"
              label="Agente ou servidor público"
              outlined
              dense
              @keyup.native="loadSeachEst()"
            >
              <v-icon
                v-if="estrutura.agente"
                slot="append"
                color="black"
                @click.prevent="clPessoa"
              >
                mdi-close
              </v-icon>
            </v-text-field>
            <v-card
              v-show="lista === 'sim'"
              class="my-0 py-0"
            >
              <ul class="filtro">
                <li
                  v-for="item in items"
                  :key="item.id"
                >
                  <a @click="loadPessoaId( item, 'novo' )"> {{ item.agente }}</a>
                </li>
              </ul>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="5"
            lg="5"
          >
            <h2>Cargo do agente</h2>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
          >
            <v-tab>
              <v-icon class="mr-2">
                mdi-map-marker-outline
              </v-icon>
              Endereço
            </v-tab>
            <v-tab>
              <v-icon class="mr-2">
                mdi-message-text-outline
              </v-icon>
              Competências
            </v-tab>
            <v-tab @click.prevent="loadDeptos()">
              <v-icon class="mr-2">
                mdi-share-variant-outline
              </v-icon>
              Departamentos
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="pa-2">
                      <ckeditor
                        :editor="editor"
                        v-model="estrutura.end_correspondencia"
                        :config="editorConfig"
                        placeholder="Endereço para correspondência"
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="pa-2">
                      <ckeditor
                        :editor="editor"
                        v-model="estrutura.ds_estrutura"
                        :config="editorConfig"
                        placeholder="Competências do departamento"
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-title>Departamentos</v-card-title>
                <v-data-table
                  :headers="headersDpto"
                  :items="departamentos"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadDepto(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                  </template>
                </v-data-table>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-btn
                      color="success"
                      class="ml-4 mb-2"
                      v-if="codigo"
                      @click="loadAddDepto"
                    >
                      <v-icon left>
                        mdi-office-building-plus-outline
                      </v-icon>
                      Adicionar dpto.
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              color="success"
              class="mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <!-- Dialog de departamentos -->
      <v-container>
        <v-dialog
          v-model="DialogDepto"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              <v-icon class="mr-2">
                mdi-pencil-box-outline
              </v-icon>
              Adicionar e editar Departamentos
            </v-toolbar>
            <v-form>
              <div class="ma-2 pt-5 px-2">
                <input
                  id="user-id"
                  type="hidden"
                  v-model="departamento.usuario"
                />
                <input
                  id="departamento-id"
                  type="hidden"
                  v-model="departamento.id"
                />
                <input
                  id="departamento-uuid"
                  type="hidden"
                  v-model="departamento.uuid"
                />
                <input
                  id="uid_departamento"
                  type="hidden"
                  v-model="departamento.uid_departamento"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codDepto"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    v-if="codDepto"
                  >
                    <v-checkbox
                      v-model="departamento.inativar"
                      label="Inativar departamento?"
                      color="success"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="departamento.departamento"
                      label="Nome do departamento"
                      required
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    lg="3"
                    class="mr-0 pr-0"
                  >
                    <v-text-field
                      class="codigo mr-0"
                      v-model="departamento.uid_agente"
                      label="Código..."
                      dense
                      outlined
                      flat
                      @change="loadPessoaIdDepto()"
                    >
                      <v-btn
                        class="btn-outer pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click="loadFtPessoa"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="light"
                        tile
                        @click="loadAddPessoa"
                      >
                        <v-icon
                          class="mx-0"
                          color="black"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="7"
                    lg="5"
                    class="mx-0 px-0"
                  >
                    <input
                      type="hidden"
                      id="dpto-agente"
                      v-model="departamento.agente"
                    />
                    <v-text-field
                      class="v-busca-nome ml-0"
                      v-model="pessoaSearch"
                      :loading="loading"
                      aria-autocomplete="none"
                      :search-input.sync="search"
                      label="Agente ou servidor público"
                      outlined
                      dense
                      @keyup.native="loadSeach()"
                    >
                      <v-icon
                        v-if="departamento.agente"
                        slot="append"
                        color="black"
                        @click.prevent="clPessoa"
                      >
                        mdi-close
                      </v-icon>
                    </v-text-field>
                    <v-card
                      v-show="listar === 'sim'"
                      class="my-0 py-0"
                    >
                      <ul class="filtro">
                        <li
                          v-for="item in items"
                          :key="item.id"
                        >
                          <a @click="loadPessoaIdDepto( item, 'novo' )"> {{ item.agente }}</a>
                        </li>
                      </ul>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="pa-2">
                      <v-card-subtitle class="pl-0 mb-0 pb-0">Formas de contato e endereço de correspondência.:</v-card-subtitle>
                      <ckeditor
                        :editor="editor"
                        v-model="departamento.end_correspondencia"
                        :config="editorConfig"
                        placeholder="Formas de contato e endereço de correspondência.:"
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="pa-2">
                      <v-card-subtitle class="pl-0 mb-0 pb-0">Competências do departamento</v-card-subtitle>
                      <ckeditor
                        :editor="editor"
                        v-model="departamento.ds_departamento"
                        :config="editorConfig"
                        placeholder="Competências do departamento"
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-form>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="!departamento.id"
                @click.prevent="addDepto()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!departamento.id"
                @click.prevent="addDepto(close = true)"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e sair
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="departamento.id"
                @click.prevent="addDepto()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="departamento.id"
                @click="delDepto()"
              >
                Excluir
                <v-icon left>
                  mdi-trash
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click.prevent="closeAddDepto"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="dialog"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="estruturas"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    medium
                    color="primary"
                    class="mr-2"
                    @click="loadAgHistorico(item, 'addhistorico')"
                  >
                    mdi-arrow-collapse-down
                  </v-icon>
                  <v-icon
                    medium
                    color="primary"
                    class="mr-2"
                    @click="loadEstrutura(item)"
                  >
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon
                    medium
                    color="error"
                    class="mr-2"
                    @click="loadEstrutura(item, 'remove')"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialog.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
export default {
  name: 'EstruturaOrganizacional',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    editor: ClassicEditor,
    editorConfig: {
    },
    close: null,
    pessoaSearch: '',
    pessoaSearchEst: '',
    uuid: '',
    tabs: null,
    btn: false,
    dtp: '##/##/####',
    dtcad: '##/##/####',
    codigo: '',
    codDepto: '',
    dialog: false,
    DialogPessoa: false,
    DialogDepto: false,
    loading: false,
    search: null,
    select: null,
    file: '',
    tabela: 'pessoas',
    mode: 'save',
    listar: '',
    lista: '',
    estrutura: {},
    departamento: {},
    pessoa: {},
    pessoas: [],
    items: [],
    estruturas: [],
    departamentos: [],
    length: '',
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome da gestão', value: 'nome' },
      { text: 'Nome do Agente', value: 'agente' },
      { text: 'Cargo', value: 'cargo' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersDpto: [
      {
        text: 'Cód.',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Departamento', value: 'departamento' },
      { text: 'Responsável', value: 'agente' },
      { text: 'Situação', value: 'situacao', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    endereco () {

    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      const method = this.estrutura.id ? 'put' : 'post'
      const id = this.estrutura.id ? `/${this.estrutura.id}` : ''
      axios[method](`${baseApiUrl}/estruturas${id}`, this.estrutura)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    addDepto (close) {
      const method = this.departamento.id ? 'put' : 'post'
      const id = this.departamento.id ? `/${this.departamento.id}` : ''
      axios[method](`${baseApiUrl}/departamentos${id}`, this.departamento)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          if (!this.departamento.id) {
            this.clearDepto()
          }
          if (close === true) {
            this.closeAddDepto()
          }
          this.loadDeptos()
        })
        .catch(showError)
    },
    delDepto () {
      alert('Deseja realmente remover o departamento?')
    },
    loadEstruturas () {
      const url = `${baseApiUrl}/estruturas`
      axios.get(url).then(res => {
        this.estruturas = res.data
      })
    },
    FecharDialog () {
      this.DialogPessoa = false
    },
    loadEstrutura (estrutura, mode = 'save') {
      this.mode = mode
      this.estrutura = { ...estrutura }
      this.codigo = estrutura.id
      this.pessoaSearchEst = estrutura.agente
      this.dialog = false
      this.clearDepto()
    },
    loadPessoaId (item) {
      const id = this.estrutura.uid_agente ? `/${this.estrutura.uid_agente}` : `/${item.uid_agente}`
      const url = `${baseApiUrl}/pessoas-da-estrutura-por-id${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.estrutura.uid_agente = this.pessoa.uid_agente
        this.estrutura.agente = this.pessoa.agente
        this.pessoaSearchEst = this.pessoa.agente
      })
      this.clPessoa()
    },
    loadPessoaIdDepto (item) {
      const id = this.departamento.uid_agente ? `/${this.departamento.uid_agente}` : `/${item.uid_agente}`
      const url = `${baseApiUrl}/pessoas-da-estrutura-por-id${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.departamento.uid_agente = this.pessoa.uid_agente
        this.departamento.agente = this.pessoa.agente
        this.pessoaSearch = this.pessoa.agente
      })
      this.clPessoa()
    },
    clPessoa () {
      this.estrutura.uid_agente = ''
      this.estrutura.agente = ''
      this.departamento.uid_agente = ''
      this.departamento.agente = ''
      this.items = []
      this.listar = ''
      this.lista = ''
      this.pessoaSearchEst = ''
      this.pessoaSearch = ''
    },
    loadSeachEst (lista = 'sim') {
      const search = this.pessoaSearchEst || 0
      const url = `${baseApiUrl}/pessoas-da-estrutura-search/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.lista = lista
    },
    loadSeach (listar = 'sim') {
      const search = this.pessoaSearch || 0
      const url = `${baseApiUrl}/pessoas-da-estrutura-search/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listar = listar
    },
    loadFtPessoa () {

    },
    loadAddPessoa () {
      this.assunto = {}
      this.DialogPessoa = true
    },
    reset () {
      this.btn = false
      this.codigo = ''
      this.codDepto = ''
      this.pessoaSearchEst = ''
      this.pessoaSearch = ''
      this.mode = 'save'
      this.pessoas = []
      this.estrutura = {}
      this.departamentos = []
      this.departamento = {}
      this.historicos = []
      this.telefones = []
      this.redes = []
      this.emails = []
    },
    limpar () {
      this.mode = 'save'
      this.historico = {}
    },
    loadDialog () {
      this.dialog = true
      this.loadEstruturas()
    },
    loadDeptos () {
      const id = this.estrutura.id
      const url = `${baseApiUrl}/departamentos-da-estrutura/${id}`
      axios.get(url).then(res => {
        this.departamentos = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 1 ? 'Inativo' : 'Ativo'
          }
        })
      })
    },
    loadDepto (item) {
      const id = item.id
      const url = `${baseApiUrl}/departamentos/${id}`
      axios.get(url).then(res => {
        this.departamento = res.data
        this.codDepto = this.departamento.id
        this.pessoaSearch = this.departamento.agente
      })
      this.DialogDepto = true
    },
    loadAddDepto () {
      this.departamento.usuario = this.user.id
      this.departamento.uuid = uuid.v1()
      this.departamento.uid_estrutura = this.estrutura.id
      this.DialogDepto = true
    },
    closeAddDepto () {
      this.DialogDepto = false
      this.clearDepto()
    },
    clearDepto () {
      this.departamento = {}
      this.codDepto = ''
      this.pessoaSearch = ''
      this.departamento.usuario = this.user.id
      this.departamento.uuid = uuid.v1()
      this.departamento.uid_estrutura = this.estrutura.id
    },
    loadUser () {
      this.estrutura.usuario = this.user.id
      this.estrutura.uuid = uuid.v1()
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style scoped>
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 750px;
}
</style>
